import {
	MarketingPage,
	MarketingSection,
} from './+shared/marketing-page.tsx'
import { type Route } from './+types/support.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Support — Muziekdocent' },
	{
		name: 'description',
		content:
			'Hulp nodig met Muziekdocent? We reageren binnen één werkdag — meestal sneller.',
	},
]

export default function SupportRoute() {
	return (
		<MarketingPage
			title="Support"
			intro="Loop je ergens tegenaan tijdens de les? We helpen je snel weer op weg."
		>
			<MarketingSection title="Direct contact">
				<p>
					Mail{' '}
					<a
						href="mailto:info@muziekdocent.nl"
						className="text-white underline underline-offset-4"
					>
						info@muziekdocent.nl
					</a>{' '}
					— we reageren binnen één werkdag, meestal sneller. Ingelogde
					docenten kunnen ook de chat rechtsonder in de app gebruiken.
				</p>
			</MarketingSection>

			<MarketingSection title="Veelgestelde vragen">
				<p>
					Werkt het op Chromebooks? Hoe zit het met AVG? Kan ik koppelen
					aan Magister? De antwoorden staan in de{' '}
					<a href="/#faq" className="text-white underline underline-offset-4">
						FAQ op de homepage
					</a>
					.
				</p>
			</MarketingSection>

			<MarketingSection title="Geen geluid in de les?">
				<p>
					De meest voorkomende oorzaak: de browser blokkeert audio tot de
					eerste klik. Laat leerlingen één keer op een pad tikken. Werkt
					het daarna nog niet, controleer dan of het schoolnetwerk
					audio-samples niet blokkeert — of mail ons, dan denken we mee.
				</p>
			</MarketingSection>
		</MarketingPage>
	)
}
